export default {
  sections: {
    coreOverview: '核心指标概览',
    uvpv: 'UV/PV 趋势分析',
    stayTime: '页面停留时长趋势',
    bounceRate: '页面跳出率趋势',
    registeredUsers: '注册用户数趋势',
    activeUsers: '活跃用户数趋势',
    certifiedCompanies: '认证企业数趋势',
    portHeat: '港口热度排行 TOP20',
    portFailure: '港口组合失败次数排行 TOP20',
    inquiryCount: '询价单量统计',
    inquiryPort: '港口组合询价排名 TOP20',
    inquiryCustomer: '客户询价排名 TOP20',
    quoteCount: '报价单量统计',
    quotePort: '港口组合报价排名 TOP20',
    quoter: '报价人排名 TOP20',
    quoteTimeliness: '报价时效统计',
    quoteEfficiency: '报价效率排名 TOP20',
    overtimeQuotes: '超时未报价列表',
    rateMaintenance: '运价维护数量统计',
    rateStatus: '运价状态分布',
    rateAvgTrend: '运价平均趋势统计',
    businessDataDashboard: '业务数据统计看板'
  },

  filters: {
    timeRange: '时间范围',
    page: '页面',
    userType: '用户性质',
    certStatus: '认证状态',
    dataScope: '数据范围',
    source: '来源',
    originPort: '起运港',
    destPort: '目的港',
    timeoutHours: '超时时间(h)',
    carrier: '船公司',
    containerSelection: '箱型选择：',
    rateType: '运价类型',
    selectContainers: '选择箱型',
    selectRateTypes: '选择运价类型',
    selectAll: '全选',
    timeDimension: '时间维度',
    route: '航线',
    salesperson: '业务员',
    containerType: '箱型'
  },

  options: {
    all: '全部',
    individual: '个人',
    joinedCompany: '已加入企业',
    pending: '待审核',
    rejected: '审核拒绝',
    approved: '审核通过',
    internal: '内部',
    external: '外部',
    group: '本集团',
    company: '本公司',
    department: '本部门',
    personal: '个人'
  },

  rateTypes: {
    fclRates: '整箱运价',
    precarriageRates: '港前运价',
    lastMileRates: '尾程运价'
  },

  charts: {
    uvpv: {
      legendUV: 'UV (独立访客)',
      legendPV: 'PV (页面浏览量)'
    },
    common: {
      emptyValue: '无数据'
    }
  },

  units: {
    seconds: '秒'
  },

  pages: {
    all: '全部页面',
    home: '首页',
    biAnalyticsPage: 'BI统计分析',
    dashboard: '仪表盘',
    controlTowerPanel: '控制塔面板',
    saasRateManagement: '运价维护',
    saasContractManagement: '合约管理',
    saasSurchargeManagement: '附加费维护',
    saasIncreaseRules: '加价规则维护',
    saasRateQuery: '运价查询',
    saasInquiryManagement: '询价管理',
    saasQuotationManagement: '报价管理',
    ordersManagement: '订单管理',
    shippingLineMaintenance: '航线维护',
    shippingScheduleQuery: '船期查询',
    customerUserManagement: '用户管理',
    customerCompanyManagement: '企业管理',
    customerRoleAuthManagement: '角色权限管理',
    userCenter: '用户中心',
    applicationCenter: '应用中心',
    apiCenter: 'API中心',
    systemSettings: '系统设置',
    basicData: '基础资料维护',
    salesMarketingLeads: '营销线索',
    salesAiCustomerAcquisition: 'AI获客'
  },

  cards: {
    uv: {
      title: 'UV (独立访客)',
      desc: 'UV 总数'
    },
    pv: {
      title: 'PV (页面浏览量)',
      desc: 'PV 总数'
    },
    stayTime: {
      title: '平均停留时长',
      desc: '平均停留时长（秒）'
    },
    bounceRate: {
      title: '跳出率',
      desc: '页面跳出率'
    }
  },

  labels: {
    registeredUsers: '注册用户数',
    activeUsers: '活跃用户数',
    certifiedCompanies: '认证企业数',
    inquiryCount: '询价单量',
    quoteCount: '报价单量',
    rateMaintenance: '运价维护数量',
    rateStatus: '运价状态',
    avgTimeliness: '平均时效',
    avgDuration: '平均时长',
    searchCount: '查询次数',
    failureCount: '失败次数',
    price: '价格(USD)'
  },

  axis: {
    orders: '{value}单',
    people: '{value}人',
    companies: '{value}家',
    times: '{value}次',
    percent: '{value}%',
    seconds: '{value}秒',
    hours: '{value}小时'
  },

  rateStatusNames: {
    pending: '待审核',
    active: '有效',
    expired: '已过期',
    offline: '下架'
  },

  overtimeQuotes: {
    columns: {
      inquiryNo: '询价单号',
      client: '客户',
      portCombo: '港口组合',
      submitTime: '提交时间',
      overtimeHours: '超时(小时)'
    }
  },

  businessDashboard: {
    title: '业务数据统计看板',
    exportData: '导出数据',
    refresh: '刷新',
    resetConditions: '重置条件',
    queryData: '查询数据',
    kpi: {
      inquiryVolume: '询价量',
      quotationVolume: '报价量',
      bookingVolume: '订舱量',
      bookingRate: '订舱率',
      cancellationVolume: '撤载量',
      cancellationRate: '撤载率',
      comparedToLastDay: '较昨天',
      comparedToLastWeek: '较上周',
      comparedToLastMonth: '较上月',
      comparedToLastQuarter: '较上季度',
      comparedToLastYear: '较上年'
    },
    table: {
      title: '航线箱量统计',
      routeName: '航线名称',
      routePath: '航线路径',
      inquiryVolume: '询价量',
      quotationVolume: '报价量',
      bookingVolumeTeu: '订舱量',
      bookingRate: '订舱率',
      cancellationVolumeTeu: '撤载量(TEU)',
      cancellationRate: '撤载率',
      operation: '操作',
      details: '详情'
    },
    timeDimensions: {
      range: '范围',
      daily: '每日',
      weekly: '每周',
      monthly: '每月',
      quarterly: '每季度',
      yearly: '每年'
    }
  },
  config: {
    title: '面板配置',
    tips: '拖拽卡片可调整显示顺序，使用开关控制卡片显示/隐藏',
    show: '显示',
    hide: '隐藏',
    save: '保存',
    reset: '重置',
    cancel: '取消',
    saveSuccess: '配置保存成功',
    saveFailed: '配置保存失败',
    resetSuccess: '已重置为默认配置'
  },
  messages: {
    calcDateRange: '计算日期范围',
    loadKpiFailed: '加载KPI数据失败',
    loadRouteStatFailed: '加载航线箱量统计数据失败',
    requestParams: '请求参数',
    interfaceResponse: '接口响应',
    rawResponse: '原始响应',
    invalidFormat: '接口返回数据格式不正确',
    updateSuccess: '表格数据已更新',
    totalCount: '分页总数',
    currentPage: '当前页码',
    loadConfigFailed: '加载卡片配置失败',
    fetchStatFailed: '获取统计范围数据失败',
    normDateRangeFailed: '规范化日期范围失败'
  }
}
